module.exports = __webpack_public_path__ + "img/monceau-fleurs.d37cbdc1.jpg";